module.exports = __webpack_public_path__ + "static/muhsis-web-3d7400a974ac4669c97d294bd1f40bdc.png";